var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookNormalWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2013 3.61936C22.8648 3.61936 22.549 3.62272 22.2326 3.63088V2.55664H21.8803C15.0346 2.55664 12.7397 4.19392 11.9995 5.0776C11.2594 4.19392 8.96448 2.55664 2.11872 2.55664H1.7664V3.6304C1.45056 3.62176 1.13472 3.61936 0.79872 3.61936H0V19.1474H0.79872C9.24432 19.1474 10.968 21.0842 11.2138 21.4437H12.7987C13.0661 21.0674 14.8234 19.1474 23.2018 19.1474H24V3.61936H23.2013ZM11.4715 18.447C10.2922 17.5773 7.81824 16.5683 2.64768 16.5011V3.44416C9.88944 3.53728 11.2882 5.52112 11.4715 5.84416V18.447ZM21.3523 16.5011C16.1818 16.5683 13.7078 17.5763 12.5285 18.447V5.84848C12.7282 5.49472 14.1662 3.53776 21.3523 3.44512V16.5011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookNormalWhite);
export default __webpack_public_path__ + "static/media/book_normal_white.284a77e176760226982b99d638600adf.svg";
export { ForwardRef as ReactComponent };